import { useEffect } from "react";
import { CheckoutSelectedFulfillmentType } from "../pages";
import {
  BuyersChoiceFulfillmentType,
  useStorefrontBuyerChoiceDeliveryOption,
} from "../pages/stockList/categoryPage/Storefront/StorefrontBuyerChoiceDeliveryOptionDialog/useStorefrontBuyerChoiceDeliveryOptions";

export const getAutoSelectedFulfillmentType = ({
  buyersChoiceFulfillmentType,
  isEligibleForDistribution,
  isEligibleForDirect,
  value,
}: {
  buyersChoiceFulfillmentType: BuyersChoiceFulfillmentType | undefined;
  isEligibleForDistribution: boolean;
  isEligibleForDirect: boolean;
  value: string | undefined | null;
}): CheckoutSelectedFulfillmentType => {
  if (value) {
    return undefined;
  }

  if (
    buyersChoiceFulfillmentType === "sellarDistribution" &&
    isEligibleForDistribution
  ) {
    return "sellarDistribution";
  }

  if (buyersChoiceFulfillmentType === "direct" && isEligibleForDirect) {
    return "direct";
  }

  if (!buyersChoiceFulfillmentType && isEligibleForDistribution) {
    return "sellarDistribution";
  }

  return undefined;
};

/**
 * Encapsulates the side effect for auto-selecting either direct or Sellar Distribution when appropriate.
 */
export const useFulfillmentTypeAutoSelect = ({
  isEligibleForDistribution,
  isEligibleForDirect,
  value,
  supplierId,
  onUpdate,
}: {
  isEligibleForDistribution: boolean;
  isEligibleForDirect: boolean;

  value: string | undefined | null;
  supplierId: number;
  onUpdate: (value: CheckoutSelectedFulfillmentType) => void;
}) => {
  const { buyersChoiceFulfillmentType } =
    useStorefrontBuyerChoiceDeliveryOption({
      supplierId,
    });

  const autoSelectedFulfillmentType = getAutoSelectedFulfillmentType({
    buyersChoiceFulfillmentType,
    isEligibleForDistribution,
    isEligibleForDirect,
    value,
  });

  useEffect(() => {
    if (autoSelectedFulfillmentType) {
      onUpdate(autoSelectedFulfillmentType);
    }
  }, [autoSelectedFulfillmentType, onUpdate]);

  return autoSelectedFulfillmentType;
};
